import React from 'react';
import ReactApexChart from 'react-apexcharts';

const CampaignAnaLytics = ({dataMap}) => {
  // Your custom data values:
  const donutChartSeries = dataMap || [0, 0, 0]; // Numeric values for each slice

  // Chart options including labels and colors:
  const donutChartOptions = {
    labels: ['COMPLETED', 'QUEUE', 'FAILED'], // Labels for the slices
    colors: ['#2563EB', '#FBBF24', '#EF4444'], // Blue, Yellow, Red or customize as needed
    legend: {
      show: false, // Hide built-in legend if you want custom legend outside
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(1) + "%"; // Show percentage values
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 280,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return (
    <div className="col-md-4">
      <div className="card h-100 radius-8 border-0 overflow-hidden">
        <div className="card-body p-24">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <div>
              <h6 className="mb-2 text-lg">Campaign Performance</h6>
              <p>Distribution by campaign type</p>
            </div>
          </div>
          <ReactApexChart options={donutChartOptions} series={donutChartSeries} type="pie" height={264} />
          <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
            <li className="d-flex align-items-center gap-2">
              <span className="w-12-px h-12-px radius-2 bg-primary-600" />
              <span className="text-secondary-light text-sm fw-normal">
                COMPLETED:
                <span className="text-primary-light fw-semibold">{donutChartSeries[0]}</span>
              </span>
            </li>
            <li className="d-flex align-items-center gap-2">
              <span className="w-12-px h-12-px radius-2 bg-yellow" />
              <span className="text-secondary-light text-sm fw-normal">
                QUEUE:
                <span className="text-primary-light fw-semibold">{donutChartSeries[1]}</span>
              </span>
            </li>
            <li className="d-flex align-items-center gap-2">
              <span className="w-12-px h-12-px radius-2 bg-red" />
              <span className="text-secondary-light text-sm fw-normal">
                FAILED:
                <span className="text-primary-light fw-semibold">{donutChartSeries[2]}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CampaignAnaLytics;
